<template>
  <div class="examVerify" v-loading="loading">
    <p class="tip_text">
      <el-row type="flex" align="middle">
        <el-col :span="4">
          <i class="el-icon-user" style="font-size:44px"></i>
        </el-col>
        <el-col class="user" :span="12" v-if="content.length > 0">
          <b>{{ content[0].user_name }}</b>
          <p>{{ content[0].user_phone }}</p>
          <p>{{ content[0].user_idcard }}</p>
        </el-col>
      </el-row>
    </p>
    <div class="container">
      <el-card class="box-card" v-for="(item, index) in content" :key="index">
        <el-row>
          <el-col :span="3">
            <div class="index_color">{{ index + 1 }}</div>
          </el-col>
          <el-col class="paper" :span="15">
            <b>{{ item.title }}</b>
            <p>试题数量：{{ item.num }}题</p>
            <p>试卷满分：{{ item.score }}分</p>
          </el-col>
          <el-col :span="3">
            <el-tag>{{ item.minutes }}分钟</el-tag>
          </el-col>
        </el-row>
        <el-divider></el-divider>
        <div class="button">
          <b v-if="item.check == 1" style="color:#ff9f43" @click="totext(item)"
            >开始考试</b
          >
          <span v-else style="color:#8491AA">{{ item.msg }}</span>
        </div>
      </el-card>
      <div style="text-aglin:center;" v-if="prompt">
        <p><i class="el-icon-warning"></i> {{ prompt }}</p>
      </div>
      <p class="tip">
        *注意 : 考生信息来源于实名注册 ,
        请确认考生信息与考试信息无误后再点击开始考试 , 考试途中不得退出。
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'examVerify',
  data() {
    return {
      user: {},
      state: true,
      text: {},
      title: '',
      loading: false,
      code: '',
      list: [1, 2, 3, 4],
      content: [],
      prompt: '',
    }
  },
  created() {
    let _this = this
    _this.getList()
  },
  methods: {
    getList() {
      let _this = this
      _this.loading = true
      _this.$http
        .get(process.env.VUE_APP_URL + 'showPaperList')
        .then(data => {
          _this.loading = false
          if (data.data.code == 200) {
            _this.content = data.data.data

            _this.content.sort((a, b) => b.check - a.check)
          } else {
            _this.prompt = data.data.msg
          }
        })
        .catch(err => {
          _this.loading = false
          _this.$message.error('网络错误，请重试')
          console.log(err)
        })
    },
    getExam() {
      let _this = this
      _this.loading = true
      _this.$http
        .get(process.env.VUE_APP_URL + 'paperShowList')
        .then(data => {
          if (data.data.code == 200) {
            let examList = data.data.data
            _this.init(examList)
          } else {
            _this.$message.error(data.data.msg)
          }
        })
        .catch(err => {
          _this.$message.error('网络错误，请重试')
          console.log(err)
        })
    },
    async init(data) {
      let _this = this
      _this.content = []
      for (var i = 0; i <= data.length; i++) {
        let newResults = await _this.getPaper(data[i].id)
        _this.content = _this.content.concat(newResults)
        _this.content.sort((a, b) => a.code - b.code)
      }
    },
    async getPaper(id) {
      return new Promise((resolve, reject) => {
        let _this = this
        _this.$http
          .get(process.env.VUE_APP_URL + 'paper/penStart/' + id)
          .then(function(data) {
            _this.loading = false
            if (data.data.code != 201) {
              resolve(data.data)
            }
          })
          .catch(function(error) {
            _this.$message.error('网络错误，请刷新界面重试')
            return
          })
      })
    },

    out() {
      this.$router.push({ name: 'Examination' })
    },
    totext(item) {
      this.$router.push({
        name: 'exam_wp',
        params: {
          id: item.id,
        },
      })
    },
  },
  mounted() {},
}
</script>

<style lang="less" scoped>
.tip_text {
  background: linear-gradient(to right, #ff9b5f 0%, #ff7a54 100%);
  color: #fff;
  padding: 20px;
}
.user {
  b {
    font-size: 18px;
  }
  p {
    font-size: 14px;
  }
}
.paper {
  b {
    font-size: 18px;
  }
  p {
    font-size: 14px;
    color: #8491aa;
  }
}
.button {
  text-align: center;
  font-size: 18px;
}
.container {
  margin: 30px;
}
.el-divider--horizontal {
  margin: 15px 0;
}
.index_color {
  width: 30px;
  height: 30px;
  border-radius: 6px;
  text-align: center;
  line-height: 30px;
  background: #ff7a54;
  color: #fff;
}
.el-card {
  margin: 10px 0;
}
.tip {
  margin-top: 30px;
  font-size: 14px;
  color: #8491aa;
}
</style>
